import Vue from 'vue';
import Router from 'vue-router';
import Userauth from '../auth/js/index';

import Body from '../components/body';
import Auth from '../auth/auth';

// component

import AdminDashboard from '../pages/dashboard/admin';
import CandidateDashboard from '../pages/dashboard/candidate';

import MatchScoring from '../pages/matchScoring/match_scoring';
import RoleModel from '../pages/roleModel/role_model';
import Login from '../pages/authentication/login';
import Register from '../pages/authentication/register';
import Profile from '../pages/users/profile';
import ProfileAdmin from '../pages/users/profile-admin';
import ListUser from '../pages/users/list';
import CreateUser from '../pages/users/form';
import ListAsessment from '../pages/asessment/listAsessment';
import DetailAsessment from '../pages/asessment/detailAsessment';

Vue.use(Router);

const routes = [
  // {
  //   path: '',
  //   redirect: {
  //     name: 'Admin'
  //   }
  // },
  {
    path: '/auth',
    component: Auth,
    children: [{
        path: 'login',
        name: 'Login',
        component: Login,
        meta: {
          title: 'Analytics Assessment for HR Practitioners',
        }
      },
      {
        path: 'register',
        name: 'Register',
        component: Register,
        meta: {
          title: 'Analytics Assessment for HR Practitioners',
        }
      }
    ]
  },
  {
    path: '/dashboard',
    component: Body,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'admin',
        name: 'Admin',
        component: AdminDashboard,
        meta: {
          title: 'Analytics Assessment for HR Practitioners',
          requiresAdmin: true
        }
      },
      {
        path: 'candidate',
        name: 'Admin',
        component: CandidateDashboard,
        meta: {
          title: 'Analytics Assessment for HR Practitioners',

        }
      }
    ]
  },
  {
    path: '/candidate',
    component: Body,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'profile',
        name: 'profileUsers',
        component: Profile,
        meta: {
          title: 'Analytics Assessment for HR Practitioners',

        }
      },
      {
        path: 'asessment',
        name: 'ListAsessment',
        component: ListAsessment,
        meta: {
          title: 'Analytics Assessment for HR Practitioners',
        },
      },
      {
        path: 'asessment/proses-asessment',
        name: 'ProsesAsessment',
        component: DetailAsessment,
        meta: {
          title: 'Analytics Assessment for HR Practitioners',
        }
      }
    ]
  },
  {
    path: '/match-scoring',
    component: Body,
    meta: {
      requiresAuth: true
    },
    children: [{
      path: '/',
      name: 'match-scoring',
      component: MatchScoring,
      meta: {
        title: 'Match Scoring | TADE Analytics',
      }
    }, ]
  },
  {
    path: '/user',
    component: Body,
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    },
    children: [ 
      {
        path: '/',
        name: 'profileUsersAdmin',
        component: ProfileAdmin,
        meta: {
          title: 'Analytics Assessment for HR Practitioners',
          requiresAdmin: true
        }
      },
      {
        path: 'list',
        name: 'listUser',
        component: ListUser,
        meta: {
          title: 'List User',
        }
      },
      {
        path: 'create',
        name: 'createUser',
        component: CreateUser,
        meta: {
          title: 'Analytics Assessment for HR Practitioners',
        },
      },
      {
        path: 'update',
        name: 'updateser',
        component: CreateUser,
        meta: {
          title: 'Analytics Assessment for HR Practitioners',
        },
      }
    ]
  },
  {
    path: '/role-model',
    component: Body,
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    },
    children: [{
      path: '/',
      name: 'role-model',
      component: RoleModel,
      meta: {
        title: 'Analytics Assessment for HR Practitioners',
      }
    }, ]
  },
  { 
      path: "*", 
      redirect: () => {
        if (Userauth.isAuthenticated()) {
          let user = JSON.parse(localStorage.getItem('user'));
          if (user.roles === 'ADMIN') {
            return { path: '/dashboard/admin' };
          }else if(user.roles === 'CANDIDATE'){
            return  { path: '/dashboard/candidate' };
          }
        }
        return { path: '/auth/login' };

        
      },
  }

];

const router = new Router({
  routes,
  base: process.env.BASE_URL,
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.title)
    document.title = to.meta.title;
  const path = ['/auth/login', '/auth/register'];
  console.log(Userauth.isAuthenticated(to.query));
  if (path.includes(to.path) || to.path === '/callback' || Userauth.isAuthenticated(to.query)) {
    return next();
  }
  next('/auth/login');
});

export default router;